import create from "zustand";
import { devtools, persist } from "zustand/middleware";

let state = (set) => ({
  langCd: '',
  nationCd: '',
  osTypeCd: '',
  isWeb: false,
  setLangCd: (data) => set(() => ({ langCd: data })),
  setNationCd: (data) => set(() => ({ nationCd: data })),
  setOsTypeCd: (data) => set(() => ({ osTypeCd: data })),
  setIsWeb: (data) => set(() => ({ isWeb: data })),
});

state = persist(state, { name: 'zeroTalkCommon', getStorage: () => localStorage });

const useCommonStore = create(devtools(state));

export default useCommonStore;
